import "./categoryForm.css";
import { useEffect, useState } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { useGetCategoryQuery, useUpdateCategoryMutation, useGetAllCategoriesQuery } from '../../services/productApi'
import { CategoryOutlined } from "@mui/icons-material";
import { AdminPageHeader, AdminCard, AdminInput, AdminTextarea, AdminSelect, LoadingButton, AdminSkeleton, AdminEmptyState, useToast } from '../../components/ui'

const CategoryEdit = () => {
  const { id } = useParams()
  const navigate = useNavigate();
  const { data: category, isLoading: categoryLoading, isError } = useGetCategoryQuery(id)
  const { data: categories } = useGetAllCategoriesQuery()
  const [updateCategory, { isLoading }] = useUpdateCategoryMutation()
  const [server_error, setServerError] = useState({})
  const [formData, setFormData] = useState(null)
  const toast = useToast();

  useEffect(() => {
    if (category) {
      setFormData({
        name: category.name,
        description: category.description,
        parent: category.parent || "",
        is_active: category.is_active,
      })
    }
  }, [category])

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const actualData = {
      name: formData.name,
      description: formData.description,
      parent: formData.parent || null,
      is_active: formData.is_active,
    };

    const res = await updateCategory({ id, data: actualData });
    if (res.error) {
      setServerError(res.error.data?.errors || {});
      toast.error("Could not update this category. Check the fields below.");
    }
    if (res.data) {
      toast.success("Category updated successfully.");
      setTimeout(() => navigate('/admin/categories'), 1200);
    }
  };

  const breadcrumbs = [{ label: "Dashboard", to: "/admin/dashboard" }, { label: "Categories", to: "/admin/categories" }, { label: "Edit" }];

  if (categoryLoading || !formData) {
    return (
      <div>
        <AdminPageHeader title="Edit Category" breadcrumbs={breadcrumbs} />
        <AdminCard><AdminSkeleton variant="card" height={200} /></AdminCard>
      </div>
    );
  }

  if (isError) {
    return (
      <div>
        <AdminPageHeader title="Edit Category" breadcrumbs={breadcrumbs} />
        <AdminEmptyState icon={<CategoryOutlined />} title="Couldn't load this category" description="Something went wrong. Try refreshing the page." />
      </div>
    );
  }

  return (
    <div>
      <AdminPageHeader title="Edit Category" breadcrumbs={breadcrumbs} />
      <AdminCard className="categoryForm">
        <form onSubmit={handleSubmit}>
          <AdminInput label="Name" name="name" value={formData.name || ""} onChange={handleChange} error={server_error.name?.[0]} required />
          <AdminTextarea label="Description" name="description" rows={4} value={formData.description || ""} onChange={handleChange} error={server_error.description?.[0]} />
          <AdminSelect label="Parent Category (optional)" name="parent" value={formData.parent || ""} onChange={handleChange} error={server_error.parent?.[0]}>
            <option value="">No parent - top level</option>
            {(categories || []).filter((c) => c.id !== Number(id)).map((c) => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </AdminSelect>
          <label className="categoryForm__checkbox">
            <input type="checkbox" name="is_active" checked={!!formData.is_active} onChange={handleChange} /> Active (visible to customers)
          </label>
          <div className="categoryForm__actions">
            <LoadingButton type="submit" loading={isLoading} loadingLabel="Saving...">Update Category</LoadingButton>
          </div>
        </form>
      </AdminCard>
    </div>
  );
}

export default CategoryEdit
